'helper'.trashAll('Facet')
'helper'.trashAll('Template')
'helper'.trashAll('Inventory')
'helper'.trashAll('NextNumber')
'helper'.trashAll('Configuration')
'helper'.trashAll('Adjustment')
'helper'.trashAll('Evaluation')
'helper'.trashAll('PO')
'helper'.trashAll('POLine')
'helper'.trashAll('POReceipt')
'helper'.trashAll('POReceiptLine')
'helper'.trashAll('Stocktake')
'helper'.trashAll('StocktakeLine')
'helper'.trashAll('Supplier')
'helper'.trashAll('Transaction')
'helper'.flushCache()
